import "../../style/scss/App.scss";
import { FaUsers } from "react-icons/fa";

export default function NoticeListItem({ notice, onSelect }) {
  if (!notice) return null;

  const id = notice.ID ?? notice.id;

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`notice-list-item-${id}`}
        onClick={() => onSelect?.(notice)}
      >
        <div className="Notice mobilePanel">
          <span className="title">
            {notice.NoticeTypeID === 907 ? <FaUsers size={1} /> : <span />}
            {notice.NoticeTypeDescription}
          </span>
          <span className="byline">{notice.Message}</span>
        </div>
      </button>
    </li>
  );
}
